import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Option } from '../select/options';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ColorType } from '../../../types/misc';
import { COLOR_STYLES, ICONS } from '../../../constants/constants';

@Component({
  selector: 'app-multi-select-advanced',
  templateUrl: './multi-select-advanced.component.html',
  styleUrls: ['./multi-select-advanced.component.scss'],
})
export class MultiSelectAdvancedComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() unspecifiedOptionTitle: string;
  @Input() customOptionTitle: string;
  @Input() options: Option[];
  @Input() fc: UntypedFormControl | undefined;
  @Input() badgeColor: ColorType;

  @Output() titleClick: EventEmitter<void> = new EventEmitter();
  @Output() createCustomItem: EventEmitter<void> = new EventEmitter();

  protected readonly COLOR_STYLES = COLOR_STYLES;
  protected readonly ICONS = ICONS;

  public selectedItems: Option[] = [];
  public subscriptions: Subscription = new Subscription();
  public unspecifiedOptionControl: FormControl<boolean> = new FormControl(
    false,
    {
      nonNullable: true,
    }
  );

  get selectedItemsCount(): number {
    return this.selectedItems.length;
  }

  get isDisabled(): boolean {
    return this.unspecifiedOptionControl.value;
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.fc?.valueChanges.subscribe((value) => {
        this.selectedItems =
          value?.map((id: number) =>
            this.options.find((option) => Number(option.id) === id)
          ) ?? [];
      })
    );

    this.subscriptions.add(
      this.unspecifiedOptionControl.valueChanges.subscribe((isChecked) => {
        if (isChecked) {
          this.selectedItems = [];
        }
      })
    );
  }

  isSelected(id: number): boolean {
    return Boolean(
      this.selectedItems.find((item) => Number(item.id) === Number(id))
    );
  }

  updateSelected(event: Event, option: Option): void {
    if (this.unspecifiedOptionControl.value) {
      return;
    }

    if ((event.target as HTMLInputElement).checked) {
      this.selectedItems.push(option);
    } else {
      this.selectedItems = this.selectedItems.filter(
        (item: Option) => Number(item.id) !== Number(option.id)
      );
    }

    this.fc?.setValue(
      this.selectedItems.map((item: Option) => item.id),
      { emitEvent: false }
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
